import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import PageWithQuery from "./PageWithQuery";
import withDefaultParams from "Services/withDefaultParams";
import RatesPopupHOC from "HOC/RatesPopupHOC";
import Routes from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";

const TableComparison = (props) => {
	const {
		ApplicationModel: { siteConfig, searcheModelOneString, searcheModel, currentRegion },
		seoBlock,
		new_house_url,
		houseId,
	} = props;

	const one_string_search = siteConfig?.settings?.one_string_search?.enabled;

	let house_id = houseId
		? parseInt(houseId)
		: one_string_search
			? +searcheModelOneString.house_id
			: +searcheModel.house_id;

	if (!house_id || !Number.isInteger(parseInt(house_id))) {
		throw new Error("Некорректный house_id");
	}

	useEffect(() => {
		sendMetriks("OPEN_TC");
		if (Routes.RatesInHouse.route === props.match.path) {
			sendMetriks("OPEN_TC_POPULAR");
		}
		if (Routes.DomaNzl.route === props.match.path) {
			sendMetriks("OPEN_TC_NZL");
		}
	}, [house_id]);

	const showQwiz = currentRegion?.hasOwnProperty("is_show_qwiz")
		? currentRegion.is_show_qwiz
		: true;

	return (
		<RatesPopupHOC>
			<PageWithQuery
				withQuiz={showQwiz}
				new_house_url={new_house_url}
				house_id={house_id}
				seoBlock={seoBlock}
			/>
		</RatesPopupHOC>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(TableComparison))));
